(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountReasonDialogController', DiscountReasonDialogController);

    DiscountReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DiscountReason'];

    function DiscountReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DiscountReason) {
        var vm = this;
        vm.discountReason = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:discountReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.discountReason.id !== null) {
                DiscountReason.update(vm.discountReason, onSaveSuccess, onSaveError);
            } else {
                DiscountReason.save(vm.discountReason, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
